import { render, staticRenderFns } from "./DumbappPage.vue?vue&type=template&id=30be2ad4&scoped=true&"
import script from "./DumbappPage.vue?vue&type=script&lang=js&"
export * from "./DumbappPage.vue?vue&type=script&lang=js&"
import style0 from "./DumbappPage.vue?vue&type=style&index=0&id=30be2ad4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be2ad4",
  null
  
)

export default component.exports